// extracted by mini-css-extract-plugin
export var contributeButton = "TutorialContributeCard-module--contribute-button--bd149";
export var maxWidthFitContent = "TutorialContributeCard-module--max-width-fit-content--0db91";